/**
 * Contact Page Content
 *
 * Content for the contact page breadcrumb, form, and map.
 */

const contactContent = {
  breadcrumb: {
    subtitle: 'Contact Us',
    title: 'ANY QUERY ?',
  },

  contactInfo: {
    title: 'Opening Hours',
    line1: 'Sunday – Thursday : 11 AM to 2 AM',
    line2: 'Friday – Saturday : 11 AM to 3 AM',
  },

  messageForm: {
    title: 'Message us',
    text: "Have a question about the our service? We're here to help, contact us today",
    submitButton: 'send your message',
  },

//   locations: [
//     {
//       id: 1,
//       city: 'New York',
//       icon: 'ny.png',
//       address: 'Restaurant St, Delicious City, NY.',
//       phone: '+88-123-123456',
//       email: 'booking@domainname.com',
//       directionLink: '#',
//     },
//     {
//       id: 2,
//       city: 'Dubai',
//       icon: 'dubai.png',
//       address: '520, Delicious City, Revenu Db.',
//       phone: '+88-123-123456',
//       email: 'booking@domainname.com',
//       directionLink: '#',
//     },
//     {
//       id: 3,
//       city: 'Paris',
//       icon: 'paris.png',
//       address: '589, Delicious Avenue PS.',
//       phone: '+88-123-123456',
//       email: 'booking@domainname.com',
//       directionLink: '#',
//     },
//     {
//       id: 4,
//       city: 'Toronto',
//       icon: 'toronto.png',
//       address: '121, Flavor Town, Toronto.',
//       phone: '+88-123-123456',
//       email: 'booking@domainname.com',
//       directionLink: '#',
//     },
//   ],

  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3337.8108331535323!2d-96.90725762417627!3d33.219055161264556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c39f3634c8675%3A0xe2f2421124b04dc9!2sHuq%20Up!5e0!3m2!1sen!2sus!4v1772324843951!5m2!1sen!2sus',
};

export default contactContent;
